import { API, authClient } from '../index';

// Get all access entries
export const getEntries = () => authClient().get(`${API}/access`);
